var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjPeso(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(0 0.342)",
    fill: "#9eaced"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.146 11.272)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1602.408,618.167a4.227,4.227,0,0,1-.747-.369,1.342,1.342,0,0,1-.455-1.156q0-3.151,0-6.3v-.246a6.344,6.344,0,0,1-2.942-1.536,10.648,10.648,0,0,1-3.07-4.844,5.2,5.2,0,0,1-.125-.621c-.473-.081-.964-.15-1.447-.252a9.135,9.135,0,0,1-4.211-1.9,1.571,1.571,0,0,1-.649-.875,1.106,1.106,0,0,1,.538-1.111.882.882,0,0,1,1.148.092,7.837,7.837,0,0,0,4.754,1.922c.184.023.372.021.553.057a2.128,2.128,0,0,0,1.346-.239,26.329,26.329,0,0,0,5.254-3.106c.309-.243.6-.507.912-.748a1.1,1.1,0,0,1,1.676.39.9.9,0,0,1-.165,1.067,12.168,12.168,0,0,1,3.047,5.816,2.2,2.2,0,0,1-.766,2.459,9.231,9.231,0,0,1-2.551,1.471c-.4.171-.406.167-.406.612,0,2.605-.012,5.211.007,7.815a1.414,1.414,0,0,1-1.139,1.569c-.011,0-.02.02-.03.031Zm-3.077-16.077c.07.172.147.356.217.542a6.277,6.277,0,0,0,1.862,2.745,4.675,4.675,0,0,0,.9.475c.03.015.085-.009.125-.024a8.486,8.486,0,0,0,2.341-1.205.2.2,0,0,0,.091-.253,8.364,8.364,0,0,0-2.347-4.158Z",
    transform: "translate(-1588.749 -595.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1598.016,596.447a2.476,2.476,0,1,1,2.459,2.49A2.475,2.475,0,0,1,1598.016,596.447Z",
    transform: "translate(-1593.451 -593.985)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjPeso);
export default __webpack_public_path__ + "static/media/OBJ-PESO.5977b354019f51882ef6eb5c0c2ff232.svg";
export { ForwardRef as ReactComponent };